// Module
var code = "<!-- Input -->\n<cjs-input ref=\"inputNumber\" inputType=\"number\" class=\"flex-container-row flex-item-auto\"></cjs-input>";
// Exports
module.exports = code;